import { useId } from 'react';
import { useTranslation } from 'react-i18next';

import { getAccountsList } from '@data/global-api-payments';
import { ChkOptionButtonGroup, ChkOptionLabel } from '@ui/checkout-components';
import { UiAccountsList } from '@ui/view-account-selection';

import { useScaPaymentDetails } from '../../hooks/useScaPaymentDetails/useScaPaymentDetails';
import { TRANSLATION_KEYS } from '../../utils/TranslationKeys';

import type { AccountsListProps } from './AccountsList.types';

export const AccountsList = ({
  selectedAccountId,
  setSelectedAccountId,
}: AccountsListProps) => {
  const { t } = useTranslation();
  const legendId = useId();
  const fieldsetId = useId();

  const { paymentDetails } = useScaPaymentDetails();
  const { allowedValues: accountsList } = getAccountsList(paymentDetails) || {};

  const options =
    accountsList?.map(({ name, description, value: accountId }) => ({
      value: accountId,
      label: <ChkOptionLabel title={name} description={description} />,
    })) ?? [];

  return (
    <UiAccountsList.Wrapper id={fieldsetId}>
      <UiAccountsList.Header id={legendId}>
        {t(TRANSLATION_KEYS.SELECT_ACCOUNT)}
      </UiAccountsList.Header>
      <ChkOptionButtonGroup
        selectedOption={selectedAccountId ?? ''}
        setSelectedOption={setSelectedAccountId}
        options={options}
        ariaLabelledby={legendId}
      />
    </UiAccountsList.Wrapper>
  );
};
